import React, { HTMLProps } from "react";

export function A(props: HTMLProps<HTMLAnchorElement>) {
  // eslint-disable-next-line jsx-a11y/anchor-has-content
  return <a className="underline text-primary-600" {...props} />;
}
